module.exports = __webpack_public_path__ + "static/interaction-1-2-dc6dd732775c19074e7419f265888c80.png";